module.exports = __webpack_public_path__ + "img/navneet.2efda81b.jpg";